import styled from 'styled-components';
import { Text, Svg, Col, Label, Row } from '@mlc/web-ui-toolkit';
import * as palette from '@mlc/mlc-palette';
import { ScreenSize, FontFamily } from '../../../../enums';
import Config from '../../../../AppConfig';
import AdvancedQuickSearch from '../QuickSearch/QuickSearch';

//Search input + button styling
const searchWhiteImg = `${Config.aemImageEnv}online/resource/images/Search_white.png`;

export const SearchButton = styled.button`
	background: ${palette.mlcOrange};
	border: none;
	color: ${palette.mlcWhite};
	font-family: ${FontFamily.charlieBold};
	font-size: 18px;
	height: 40px;
	margin: 0;
	padding: 0;
	vertical-align: middle;
	width: 103px;

	&:focus,
	&:hover {
		cursor: pointer;
		text-decoration: underline;
	}

	@media (max-width: ${ScreenSize.medium}) {
		padding: 0 25px !important;
		width: auto;
	}

	@media (max-width: ${ScreenSize.xSmall}) {
		background-image: url(${searchWhiteImg});
		background-position: center center;
		background-repeat: no-repeat;
		text-indent: -9999px;
	}
`;

export const SearchIcon = styled.span`
	margin-left: 5px;
`;

export const SearchInputWrapper = styled.div`
	display: flex;
	flex: 1;
	flex-direction: row;
	margin: 10px 0;

	span {
		margin-bottom: 0;
	}

	@media (max-width: ${ScreenSize.medium}) {
		width: 100%;
	}
`;

export const AdvancedSearchInputColumn = styled(Col)`
	align-items: center;
	display: flex;
	padding: 10px;
`;

export const AdvancedSearchFiltersColumn = styled(Col)`
	align-items: center;
	display: flex;
	justify-content: flex-end;
	padding-top: 17px;
	position: static;

	@media (max-width: ${ScreenSize.small}) {
		justify-content: flex-start;
	}
`;

export const ViewGroupsColumn = styled(Col)`
	align-items: center;
	display: flex;
	justify-content: flex-end;
	padding-top: 17px;
	position: initial;

	@media (max-width: ${ScreenSize.small}) {
		justify-content: flex-start;
		padding-top: 0;
	}
`;

export const QuickSearch = styled(AdvancedQuickSearch)`
	align-items: center;
	background-color: ${palette.mlcWhite};
	border: thin solid ${palette.mlcDove};
	border-right: 0;
	height: 40px;
	position: relative;
	width: 100%;

	@media (max-width: ${ScreenSize.medium}) {
		display: flex;
	}

	#searchBtnId {
		height: 40px;
	}

	.Autosuggest {
		height: 100%;
		width: 100%;

		@media (max-width: ${ScreenSize.medium}) {
			flex-grow: 1;
			height: 100%;
			width: 100%;
		}

		.InputWrapper {
			height: 100%;
			margin-bottom: 0;
		}

		.autosuggest__container {
			height: 100%;
		}

		.autosuggest__input {
			background: ${palette.mlcWhite};
			height: 100%;
			text-overflow: ellipsis;
			width: 100%;

			@media (min-width: ${ScreenSize.medium}) {
				height: 100%;
				width: 100%;
			}

			@media (max-width: ${ScreenSize.medium}) {
				height: 100%;
			}
		}

		.autosuggest__suggestions-container--open {
			background-color: ${palette.mlcWhite};
			box-shadow: 0 1px 3px 0 ${palette.mlcBlack};
			width: 100%;
		}

		.autosuggest__suggestion {
			border-bottom: 0.3px solid #979797;
			font-size: 18px;
			padding: 10px 20px;
		}

		.autosuggest__suggestion--highlighted {
			background-color: ${palette.mlcKoala};
			color: ${palette.mlcAqua};
			text-decoration: underline;
		}

		.autosuggest__section-title {
			font-size: 13px;
			margin: 5px 0 0;
			padding: 6px 4px;
		}
	}
`;

export const AdvancedSearchWrapper = styled.div`
	background-color: ${palette.mlcCore};
	margin-bottom: 30px;
`;

export const FiltersWrapper = styled.div`
	width: 100%;
`;

export const SearchBar = styled(Row)`
	height: 80px;

	@media (max-width: ${ScreenSize.small}) {
		height: auto;
	}
`;
